import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
import { useCatalog } from "../context/CatalogContext.jsx";
import { DEFAULT_CATALOG } from "../config/catalog";

const CheckoutDialog = ({ 
  open, 
  onOpenChange, 
  cart, 
  onProcessCheckout, 
  submitting 
}) => {
  const { catalog } = useCatalog();
  const data = catalog ?? DEFAULT_CATALOG;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Resumen de pedido</DialogTitle>
          <DialogDescription>Revisá tus items.</DialogDescription>
        </DialogHeader>

        <div className="space-y-3 max-h-[45vh] overflow-auto pr-1">
          {cart.map((item) => {
            const sizeMeta = data.sizes.find((s) => s.id === item.size);
            const flavorMeta = data.flavors.find((f) => f.id === item.flavor);
            const flavorLabel = flavorMeta?.label ?? (item.flavor === 'custom' ? 'Como yo lo quiero' : item.flavor);
            
            return (
              <div key={item.id} className="flex items-start justify-between">
                <div className="text-sm">
                  <div className="font-medium">
                    {item.quantity}× {sizeMeta?.label}{" "}
                    {flavorLabel}
                  </div>
                  <div className="text-xs text-neutral-600">
                    <div>Acidez: {data.acidez[item.acidezIndex]}</div>
                    <div>Textura: {data.textura[item.texturaIndex]}</div>
                    {item.toppings.length > 0 ? (
                      <span>
                        {item.toppings
                          .map((id) => data.toppings.find((t) => t.id === id)?.label)
                          .filter(Boolean)
                          .join(", ")}
                      </span>
                    ) : (
                      <span>Sin toppings</span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
          {cart.length === 0 && (
            <p className="text-sm text-neutral-500">Tu carrito está vacío.</p>
          )}
        </div>

        <Separator />

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Seguir comprando
          </Button>
          <Button 
            variant="pastelOrange" 
            onClick={onProcessCheckout} 
            disabled={cart.length === 0 || submitting}
          >
            {submitting ? "Enviando…" : "Enviar por WhatsApp"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

CheckoutDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  cart: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    flavor: PropTypes.string.isRequired,
    toppings: PropTypes.arrayOf(PropTypes.string).isRequired,
    acidezIndex: PropTypes.number.isRequired,
    texturaIndex: PropTypes.number.isRequired,
    quantity: PropTypes.number.isRequired,
  })).isRequired,
  onProcessCheckout: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default React.memo(CheckoutDialog);
